<div class="lum-c-ag-grid-sidemenu">
  <ng-container *ngIf="enablePrimaryMenu">
    <mat-nav-list class="lum-c-ag-grid-sidemenu__presets p-0">
      <mat-list-item
        *ngFor="let menu of menuItems; let i = index; trackBy: trackByLabel"
        class="lum-c-ag-grid-sidemenu__preset"
        [ngClass]="menu?.cssClass || []"
        [class.active]="menu.name === activeMenu"
        [disabled]="menu?.disabled || false"
        [ngStyle]="menu.disabled ? disabledItemStyle : {}"
        role="button"
        (click)="onSetMenuActive(menu.name)"
      >
        <ng-container *ngIf="config.renderHtml; else default">
          <div
            matListItemTitle
            class="lum-c-ag-grid-sidemenu__preset-inner"
            [innerHTML]="config.renderHtml(menu)"
          ></div>
        </ng-container>

        <ng-template #default>
          <span class="lum-c-ag-grid-sidemenu__preset-inner" matListItemTitle>
            <lum-ui-icon
              class="mr-2-5"
              icon="chevron-right"
              color="#54555a"
              width="16"
              height="16"
            ></lum-ui-icon>
            {{ menu.label }}
          </span>
        </ng-template>
      </mat-list-item>
    </mat-nav-list>
  </ng-container>

  <ng-container
    *ngIf="
      ('red_DV-2488_sales_order_grid_custom_filters' | featureFlag) &&
      enableCustomFilters &&
      !loadingCustomFilters
    "
  >
    <mat-divider *ngIf="customFilters?.length && enablePrimaryMenu"></mat-divider>
    <mat-nav-list class="lum-c-ag-grid-sidemenu__custom-filters p-0">
      <mat-list-item
        *ngFor="let filter of customFilters; trackBy: trackById"
        class="lum-c-ag-grid-sidemenu__custom-filter"
        [class.active]="filter.name === activeMenu"
        role="button"
        (click)="onSetFilter('set', filter)"
      >
        <span class="item-title flex align-items-center" matListItemTitle>
          <lum-ui-icon
            class="mr-2-5"
            icon="chevron-right"
            color="#54555a"
            width="16"
            height="16"
          ></lum-ui-icon>
          {{ filter.name }}
        </span>

        <mat-icon
          class="lum-c-ag-grid-sidemenu__custom-filter__context-toggle"
          role="button"
          [matMenuTriggerFor]="sidemenuItemContextMenu"
          (click)="$event.stopPropagation()"
          >more_vert</mat-icon
        >
        <mat-menu #sidemenuItemContextMenu="matMenu">
          <button mat-menu-item (click)="onSetFilter('edit', filter)">
            <span>Rename</span>
          </button>
          <button mat-menu-item (click)="onSetFilter('delete', filter)">
            <span>Delete</span>
          </button>
        </mat-menu>
      </mat-list-item>
      <mat-divider></mat-divider>

      <mat-list-item role="button" (click)="onSaveFilter()">
        <span class="item-title flex align-items-center" matListItemTitle>
          <lum-ui-icon
            class="mr-2"
            icon="content-save"
            color="#54555a"
            width="14"
            height="14"
          ></lum-ui-icon>
          Save Filter
        </span>
      </mat-list-item>
    </mat-nav-list>
  </ng-container>
</div>
